// Core
import { Component } from '@angular/core';

// Components
import { IndexMasterheadSection } from "./components/index-masterhead-section/index-masterhead-section";
import { IndexAboutSection } from './components/index-about-section/index-about-section';
import { IndexServicesSection } from "./components/index-services-section/index-services-section";
import { IndexPricingSection } from "./components/index-pricing-section/index-pricing-section";
import { IndexCeoSection } from "./components/index-ceo-section/index-ceo-section";
import { IndexContactSection } from "./components/index-contact-section/index-contact-section";
import { IndexNewsletterSection } from "./components/index-newsletter-section/index-newsletter-section";
import { FooterSection } from "../shared/components/footer-section/footer-section";

@Component({
    standalone: true,
    selector: 'app-index-page',
    imports: [IndexMasterheadSection, IndexAboutSection, IndexServicesSection, IndexPricingSection, IndexCeoSection, IndexContactSection, IndexNewsletterSection, FooterSection],
    templateUrl: './index-page.html',
    styleUrl: './index-page.scss',
})

export class IndexPage {

    
}
